import styled from "styled-components";
import React from "react";

const Wrapper = styled.div`
	padding: 24px 0 40px 0;
	color: ${(props) => props.theme.color.white};
	margin-bottom: 24px;
`;

const DetailSection: React.FC<{ className?: string }> = ({ children, className }) => {
	return <Wrapper className={className}>{children}</Wrapper>;
};

export default DetailSection;
